module.exports = __webpack_public_path__ + "static/img/content01.6bae51cb.png";